import { render, staticRenderFns } from "./ProfileDeleteModal.vue?vue&type=template&id=5dee2197&scoped=true&"
import script from "./ProfileDeleteModal.vue?vue&type=script&lang=js&"
export * from "./ProfileDeleteModal.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDeleteModal.vue?vue&type=style&index=0&id=5dee2197&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dee2197",
  null
  
)

export default component.exports